import apiClient from "./client";

export const login = (email, password) =>
  apiClient.post("/api/client/login", { email, password });

export const register = (formData) =>
  apiClient.post("/api/client/register", formData);

export const logout = () => apiClient.post("/api/client/logout");

export const getCurrentUser = () => apiClient.get("/api/client/me");

export const forgotPassword = (email) =>
  apiClient.post("/api/client/forgot-password", { email });

export const resetPassword = (token, newPassword) =>
  apiClient.post("/api/client/reset-password", { token, newPassword });
